import React, { useState } from 'react';
import { FadeIn } from '../animations/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const faqs = [
  {
    q: "Is Curve free?",
    a: "Curve offers a generous free tier that includes all core tracking features. We offer an optional premium upgrade for advanced charts and custom export options, which supports our ad-free, privacy-first model."
  },
  {
    q: "Does it work with all GLP-1 meds?",
    a: "Yes. You can log Wegovy, Ozempic, Mounjaro, Zepbound, Rybelsus, or create a custom entry. The app adapts to daily or weekly schedules."
  },
  {
    q: "Is my data private?",
    a: "Absolutely. We don't require an account, and your data is stored locally on your device or in your personal iCloud/Google Drive backup. We never sell your data."
  },
  {
    q: "Is this medical advice?",
    a: "No. Curve is strictly a tracking tool. It is not a medical device and does not provide medical advice. Always consult your healthcare provider regarding your medication, dosage, and health."
  }
];

const FAQItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200 py-5">
      <button 
        className="w-full flex justify-between items-center text-left focus:outline-none"
        onClick={onClick}
      >
        <span className="text-lg font-medium text-ink pr-8">{faq.q}</span>
        <SafeIcon 
          name="ChevronDown" 
          className={`text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <p className="pt-4 text-ink/70 font-light leading-relaxed">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <FadeIn className="text-center mb-16">
          <h2 className="text-4xl font-semibold tracking-tight text-ink">Common questions</h2>
        </FadeIn>

        <FadeIn delay={0.2}>
          <div className="border-t border-gray-200">
            {faqs.map((faq, index) => (
              <FAQItem 
                key={index} 
                faq={faq} 
                isOpen={openIndex === index}
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};